module.exports = __webpack_public_path__ + "static/img/far1_active.fe0acf8b.png";